import React, { FC, ReactNode } from 'react';
import { ReactComponent as Vector } from './assets/coolVector.svg';
import { GraniteButton } from 'components/V2/Button/GraniteButton';

interface QuoteRebillModalWrapperProps {
  children: ReactNode;
  type: 'comparison' | 'rebill';
  onOtherOptionsClick?: () => void;
  onBackClick?: () => void;
  onConsolidateServiceClick?: () => void;
  onCheckout?: () => void;
}

const QuoteRebillModalWrapper: FC<QuoteRebillModalWrapperProps> = ({
  children,
  type,
  onOtherOptionsClick,
  onBackClick,
  onConsolidateServiceClick,
  onCheckout,
}) => {
  return (
    <div className="relative overflow-hidden">
      <div className="pointer-events-none absolute inset-0">
        <Vector />
      </div>
      <div className="relative z-10 flex h-[848px] flex-col items-center justify-between p-8">
        <div className="flex flex-col items-center gap-10 pt-8">
          <p className="text-[52px] font-bold leading-[64px] text-content-base-default">
            {type === 'comparison' && 'Our quote.'}
            {type === 'rebill' && 'One bill.'}
            <span className="bg-[linear-gradient(90deg,_#7E77B3_-1.27%,_#8989FF_24.05%,_#6C9DFF_49.26%,_#78CFDA_74.68%,_#9FF4A9_100%)] bg-clip-text text-transparent">
              {type === 'comparison' && 'Your savings.'}
              {type === 'rebill' && 'All your services.'}
            </span>
          </p>
          {children}
        </div>
        <div className="mt-4 flex justify-center gap-5">
          {type === 'comparison' && (
            <>
              <GraniteButton
                size="large"
                variant="secondary"
                onClick={onOtherOptionsClick}
              >
                Other options
              </GraniteButton>
              <GraniteButton size="large" onClick={onCheckout}>
                Checkout
              </GraniteButton>
            </>
          )}
          {type === 'rebill' && (
            <>
              {onBackClick && (
                <GraniteButton
                  size="large"
                  variant="secondary"
                  onClick={() => {
                    onBackClick?.();
                  }}
                >
                  Back
                </GraniteButton>
              )}
              {/* <GraniteButton size="large" variant="secondary">
                Learn more
              </GraniteButton> */}
              <GraniteButton
                size="large"
                variant="tertiary"
                onClick={onConsolidateServiceClick}
              >
                Consolidate service
              </GraniteButton>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default QuoteRebillModalWrapper;
